import { Box, SxProps, Theme } from "@mui/material";
import { ReactNode, forwardRef } from "react";
import { useRef, useState, useEffect } from "react";
import { Tooltip } from "@mui/material";

export type Props = {
  children?: ReactNode;
  lines?: number;
  sx?: SxProps<Theme>;
  id?: string;
};

export const ClampWithTooltip = ({
  children,
  lines = 1,
  sx,
  id,
  ...props
}: Props) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isClamped, setIsClamped] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      // Check if content is actually clamped
      setIsClamped(textRef.current.scrollHeight > textRef.current.clientHeight);
    }

    // Re-check if window resizes
    const checkClamp = () => {
      if (textRef.current) {
        setIsClamped(
          textRef.current.scrollHeight > textRef.current.clientHeight,
        );
      }
    };

    window.addEventListener("resize", checkClamp);
    return () => window.removeEventListener("resize", checkClamp);
  }, [children]);

  const tooltipTitle = isClamped ? children : "";

  return (
    <Tooltip title={tooltipTitle} placement="top">
      <Box
        id={id}
        ref={textRef}
        {...props}
        sx={[
          {
            display: "-webkit-box",
            WebkitLineClamp: lines,
            WebkitBoxOrient: "vertical",
            fontSize: "14px",
            overflow: "hidden",
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        {children}
      </Box>
    </Tooltip>
  );
};
